import { render, staticRenderFns } from "./ValidCode.vue?vue&type=template&id=512176e2&scoped=true"
import script from "./ValidCode.vue?vue&type=script&lang=js"
export * from "./ValidCode.vue?vue&type=script&lang=js"
import style0 from "./ValidCode.vue?vue&type=style&index=0&id=512176e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512176e2",
  null
  
)

export default component.exports